import { Location } from 'history';
import React from 'react';
import posed, { PoseGroup } from 'react-pose';
import { Switch } from 'react-router-dom';

import AsyncLoad from './components/common/AsyncLoad';
import { AuthRoutes, BaseAuthRoute, WmsValidAccountRoute } from './components/common/Route';
import {
  ACCOUNT_PATH,
  BILLING_PATH,
  BYOC_PATH,
  CONFIGURATIONS_PATH,
  ROOT_PATH,
  STATISTICS_PATH,
} from './constants/paths/internal';
import { withTracker } from './hocs';

export const RouteContainer = posed.div({
  enter: { opacity: 1, beforeChildren: true, delay: 125 },
  exit: { opacity: 0 },
});

const AsyncDashboard = AsyncLoad({
  loader: () => import('./pages/Dashboard'),
}) as React.ComponentClass<any>;
const AsyncDashboardWithTracker = withTracker(AsyncDashboard);

const AsyncAccount = AsyncLoad({
  loader: () => import('./pages/Account'),
}) as React.ComponentClass<any>;
const AsyncAccountWithTracker = withTracker(AsyncAccount);

const AsyncStatistics = AsyncLoad({
  loader: () => import('./pages/Statistics'),
}) as React.ComponentClass<any>;
const AsyncStatisticsWithTracker = withTracker(AsyncStatistics);

const AsyncInstances = AsyncLoad({
  loader: () => import('./pages/Instances'),
}) as React.ComponentClass<any>;
const AsyncInstancesWithTracker = withTracker(AsyncInstances);

const AsyncInstanceDetail = AsyncLoad({
  loader: () => import('./pages/InstanceDetail'),
}) as React.ComponentClass<any>;
const AsyncInstanceDetailWithTracker = withTracker(AsyncInstanceDetail);

const AsyncBillingPage = AsyncLoad({
  loader: () => import('./pages/Billing'),
}) as React.ComponentClass<any>;
const AsyncBillingPageWithTracker = withTracker(AsyncBillingPage);

const AsyncByocPage = AsyncLoad({
  loader: () => import('./pages/Byoc'),
}) as React.ComponentClass<any>;
const AsyncByocPageWithTracker = withTracker(AsyncByocPage);

export default ({ location }: { location: Location }) => {
  return (
    <AuthRoutes location={location}>
      <PoseGroup className="auth-routes-container">
        <RouteContainer key={location.pathname}>
          <Switch location={location}>
            <WmsValidAccountRoute exact path={ROOT_PATH} component={AsyncDashboardWithTracker} />

            <BaseAuthRoute exact path={ACCOUNT_PATH} component={AsyncAccountWithTracker} />
            <BaseAuthRoute exact path={STATISTICS_PATH} component={AsyncStatisticsWithTracker} />
            <BaseAuthRoute path={BILLING_PATH} component={AsyncBillingPageWithTracker} />

            <WmsValidAccountRoute
              exact
              path={CONFIGURATIONS_PATH}
              component={AsyncInstancesWithTracker}
            />
            <WmsValidAccountRoute
              exact
              path={`${CONFIGURATIONS_PATH}/:id`}
              component={AsyncInstanceDetailWithTracker}
            />
            <WmsValidAccountRoute path={BYOC_PATH} component={AsyncByocPageWithTracker} />
          </Switch>
        </RouteContainer>
      </PoseGroup>
    </AuthRoutes>
  );
};
